import { useState } from "react";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import Info from "../../../assets/client/info-outlined.svg?react";
import styles from "./MissedConnectionDisclaimer.module.scss";
import { MissedConnectionDisclaimerModal } from "@/components/MissedConnectionDisclaimerModal";

export interface IMissedConnectionDisclaimerProps {
  modal?: boolean;
  className?: string;
}

export const MissedConnectionDisclaimer = ({
  modal,
  className,
}: IMissedConnectionDisclaimerProps) => {
  const { t } = useI18nContext();
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);

  return (
    <>
      <div
        className={clsx(styles.MissedConnectionDisclaimer, className, {
          modal,
        })}
      >
        <Trans
          i18nKey="missedConnectionIncluded"
          components={[
            <span
              className={styles.MissedConnectionDisclaimerCta}
              onClick={(e) => {
                handleOpenModal(e);
              }}
              role="button"
              tabIndex={0}
              aria-label={t("missedConnectionInfoPopup.header")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleOpenModal(e);
                }
              }}
            />,
            <Info
              onClick={(e) => {
                handleOpenModal(e);
              }}
              role="button"
            />,
          ]}
        />
      </div>
      <MissedConnectionDisclaimerModal
        open={openModal}
        onClose={handleCloseModal}
      />
    </>
  );
};
